import React, {useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';

import logo from '../../../assets/images/logo.png'
import {Menu} from 'primereact/menu';
import {Toast} from 'primereact/toast';
import {useMountEffect} from 'primereact/hooks';
import StorageHelper from '../../../utils/storage-helper';

const Header = () => {

    const [userType, setUserType] = useState([]);
    const [fullName, setFullName] = useState([]);
    const [initialsName, setInitialsName] = useState([]);
    useMountEffect(() => {
        const fetchUserRole = async () => {
            try {
                setUserType((StorageHelper.get('userType')));
                setInitialsName(StorageHelper.get('firstName').charAt(0) + "" + (StorageHelper.get('lastName').charAt(0)));
                let fullName = StorageHelper.get('firstName').toString() + " " + StorageHelper.get('lastName').toString();
                setFullName(fullName);

            } catch (error) {
                console.error('Error fetching user userRole:', error);
            }
        };
        fetchUserRole();
    });

    const menuRight = useRef(null);
    const toast = useRef(null);

    useEffect(() => {
        document.body.classList.add('has-admin-header');
        return () => document.body.classList.remove('has-admin-header');
    }, []);

    if (userType === 'CUSTOMER') {
        return null;
    }

    const items = [
        {
            label: fullName,
        },

        {
            // label: 'Manage Profile',
            items: [

                // {
                //     label: 'Edit Profile',
                //     icon: 'pi pi-user',
                //     command: () => {
                //         toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Data Updated', life: 3000 });
                //     },

                // },
                // {
                //     label: 'Change Password',
                //     icon: 'pi pi-lock',
                //     command: () => {
                //         toast.current.show({ severity: 'warn', summary: 'Delete', detail: 'Data Deleted', life: 3000 });
                //     }
                // }
            ]
        },
        {separator: true},
        {
            label: <strong>Logout</strong>,
            icon: 'pi pi-sign-out',
            url: '/signin'
        }
    ];

    return (
        <>
            <Toast ref={toast}></Toast>
            <div className="navbar bg-base-100 shadow-sm border-b border-base-200 fixed top-0 w-full z-[100] h-16 px-4">
                <div className="flex-1 gap-2">
                    <Link to={"/"} className="btn btn-ghost normal-case text-xl p-0 hover:bg-transparent">
                        <img src={logo} className="h-10 w-auto" alt="Doves Logo"/>
                    </Link>
                </div>

                <div className="flex-none gap-2">
                    <Menu model={items} popup ref={menuRight} id="popup_menu_right" popupAlignment="right"
                          className="mt-2"/>
                    <button
                        className="btn btn-ghost btn-circle avatar bg-primary text-primary-content hover:bg-primary hover:text-primary-content"
                        onClick={(event) => menuRight.current.toggle(event)}
                        aria-controls="popup_menu_right"
                        aria-haspopup
                    >
                        <div className="avatar-placeholder w-10 rounded-full flex items-center justify-center text-lg">
                            {initialsName}
                        </div>
                    </button>
                </div>
            </div>
        </>
    );
};

export default Header;
